import { render, staticRenderFns } from "./appraisalBindCourseList.vue?vue&type=template&id=5a8b1f92"
import script from "./appraisalBindCourseList.vue?vue&type=script&lang=js"
export * from "./appraisalBindCourseList.vue?vue&type=script&lang=js"
import style0 from "./appraisalBindCourseList.vue?vue&type=style&index=0&id=5a8b1f92&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports